import {visit} from 'unist-util-visit';
import type {Link, Parent, Root, Text} from 'mdast';
import {CollectionName} from '@types';

export function setCollectionNames(names: CollectionName[]) {
    localStorage.setItem('collectionNames', JSON.stringify(names));
}

export function transformCollectionLinks(
    names?: CollectionName[]
): (tree: Root) => void {
    return (tree: Root) => {
        const raw = localStorage.getItem('collectionNames');
        const collectionNames: CollectionName[] =
            names ?? (raw ? JSON.parse(raw) : []);

        visit(tree, 'text', (node: Text, index, parent) => {
            if (!parent || index === undefined) return;
            const regex = /\[c#(\d+)\]/g;
            const segments: (Text | Link)[] = [];
            let lastIndex = 0;
            let match;

            while ((match = regex.exec(node.value)) !== null) {
                const [raw, id] = match;
                const start = match.index;
                const name =
                    collectionNames.find(c => c.id.toString() === id)?.name ||
                    `Collection #${id}`;

                if (start > lastIndex) {
                    segments.push({
                        type: 'text',
                        value: node.value.slice(lastIndex, start),
                    } as Text);
                }
                segments.push({
                    type: 'link',
                    url: `/collections/${id}`,
                    title: null,
                    children: [{type: 'text', value: name}],
                } as import('mdast').Link);
                lastIndex = start + raw.length;
            }

            if (lastIndex < node.value.length) {
                segments.push({
                    type: 'text',
                    value: node.value.slice(lastIndex),
                } as Text);
            }

            if (segments.length > 0) {
                (parent as Parent).children.splice(index, 1, ...segments);
            }
        });
    };
}
